export function upload(file, progressCallback = (p) => { }, extra = {}) {
    return new Promise(async (resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        formData.append("file", file);
        for (let k in extra) {
            formData.append(k, JSON.stringify(extra[k]));
        }
        xhr.upload.onprogress = (e) => {
            if (e.lengthComputable) {
                const progress = Math.floor((e.loaded * 100) / e.total);
                progressCallback(progress);
            }
        };
        xhr.upload.onloadstart = (e) => {
            progressCallback(0);
        };
        xhr.onload = (e) => {
            progressCallback(100);
            const { status, responseText } = xhr;
            if (status === 200) {
                resolve();
            }
            else {
                reject();
                console.log("upload failed!", status, responseText);
            }
        };
        xhr.open("POST", `/upload.php`, true);
        progressCallback(0);
        xhr.send(formData);
    });
}
export function clone(o) {
    return window['structuredClone'] ? window['structuredClone'](o) : JSON.parse(JSON.stringify(o));
}
export function reduce(numerator, denominator) {
    let gcdfn = (a, b) => {
        return b ? gcdfn(b, a % b) : a;
    };
    const gcd = gcdfn(numerator, denominator);
    return [numerator / gcd, denominator / gcd];
}
export function getLocalizedValue(object, key, langCode) {
    var _a;
    return (_a = object[`${key}_${langCode}`]) !== null && _a !== void 0 ? _a : object[key];
}
